/* ------------------------------------------------------------------------------
@name: Section7
@description: Section7
--------------------------------------------------------------------------------- */

const Section7 = (() => {
  // - section7
  const handleSection7 = () => {
    // init controller
    $(".btn-scrollto-4").click(function () {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(".penanda-5-start-1").offset().top,
        },
        1000
      );
    });
  };

  // - init
  const init = () => {
    handleSection7();
  };

  return {
    init,
  };
})();

export default Section7;
